import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { toast } from "react-toastify";
import http from "../../../utils/http";


type Payload = {
  firstCallDuration: number,
  followUpCallDuration: number,
  Monday?: string[][]
  Tuesday?: string[][]
  Wednesday?: string[][]
  Thursday?: string[][]
  Friday?: string[][]
  Saturday?: string[][]
  Sunday?: string[][]
  offset: number
}

export const useCreateOrUpdateProviderSchedule = () => {
  const queryClient = useQueryClient();
  const { mutate, data, variables, reset, ...rest } = useMutation({
    mutationKey: ['create or update provider schedule'],
    mutationFn: async ({ ...data }: Payload) => {
      const response = await http.put(`schedule/provider`, { ...data })
      return response.data;
    },

    onMutate: () => {
      const toastId = toast.loading('Please wait...')
      return { toastId }
    },

    onSuccess: (_data, _variables, context) => {
      const { toastId } = context
      toast.update(toastId, {
        render: "Schedule updated!",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        closeButton: true
      });
      queryClient.invalidateQueries({ queryKey: ['get provider schedule'] as const });
    },

    onError: (error, _variables, context) => {
      const toastId = context?.toastId as number

      if (axios.isAxiosError(error)) {
        toast.update(toastId, {
          render: error?.response?.data?.error || error.response?.statusText,
          type: "error",
          isLoading: false,
          autoClose: 5000,
          closeButton: true,
        })
      } else {
        toast.update(toastId, {
          render: error?.message || "Error updating schedule.",
          type: "error",
          isLoading: false,
          autoClose: 5000,
          closeButton: true,
        });
      }
    },
  });

  return {
    createOrUpdateProviderSchedule: mutate,
    updateSchedule: data,
    variables,
    ...rest,
  };
}
